<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RwyHaB/tc-custom/9781439126332.jpg?1730537181574" alt="This image is the cover for the book Potatoes Not Prozac"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Potatoes Not Prozac
      </h1>
      <p class="bookDescription body article font2">
        <b>Can't say no to fattening foods, alcohol or compulsive behaviors?</b><br/>You're not lazy, self-indulgent or undisciplined; you may be one of the millions of people who are sugar sensitive. Many people who suffer from sugar sensitivity don't even know it; they continue to consume large quantities of sweets, breads, pasta or alcohol. These foods can trigger feelings of exhaustion and low self-esteem, yet their biochemical impact makes sugar-sensitive people crave them even more. This vicious cycle can continue for years, leaving sufferers overweight, fatigued, depressed and sometimes alcoholic.<br/>Now there is a solution: in <i>Potatoes Not Prozac</i> Dr. Kathleen DesMaisons gives you the tools you need to overcome sugar dependency, with self-tests to determine your sugar sensitivity as well as an easy-to-follow, drug-free program with a customized diet high in protein and complex carbohydrates. Join the thousands of people who have successfully healed their addiction to sugar, lost weight and attained maximum health and well-being by using Dr. DesMaisons's innovative plan.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathleen DesMaisons
      </h2>
      
      <p class="authorDescription body article">Kathleen DesMaisons, PhD coined the term &ldquo;sugar sensitivity&rdquo; and is the world&#39;s leading expert on addictive nutrition,&#160;using dietary change to support long term healing of addiction. Her bestselling book,&#160;<I>Potatoes Not Prozac</I>, continues to demystify very complex processes through her warm, compassionate, and clear style. She has more than thirty years&rsquo; experience working in public health,&#160;nutrition,&#160;and childhood health. She lives in Albuquerque, New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cc18433